import { render, staticRenderFns } from "./TableBasic.vue?vue&type=template&id=f6a20bd2&"
import script from "./TableBasic.vue?vue&type=script&lang=js&"
export * from "./TableBasic.vue?vue&type=script&lang=js&"
import style0 from "./TableBasic.vue?vue&type=style&index=0&id=f6a20bd2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6a20bd2')) {
      api.createRecord('f6a20bd2', component.options)
    } else {
      api.reload('f6a20bd2', component.options)
    }
    module.hot.accept("./TableBasic.vue?vue&type=template&id=f6a20bd2&", function () {
      api.rerender('f6a20bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsG/TableBasic.vue"
export default component.exports